// React
import React, { useState } from 'react';
// Components
import SubscriptionCard from '../../widgets/SubscriptionCard';
import { AppObject } from '../../widgets/AppCard';
import NoApps from '../../widgets/NoApps';
// Styling
import { Theme } from '@fluentui/react';
import { SubscriptionsContainer, SubscriptionsContent } from './styles';
import { useTranslation } from 'react-i18next';
import { HelpPanel } from '../../widgets/HelpPanel';
import { TutorialPopover } from '../../widgets/TutorialPopover';

type EntObject = {
  apps: string[];
  subscriptions: string[];
};

type SubscriptionProps = {
  appsObj: AppObject[];
  entObj: EntObject;
  currentUser: string;
  tid: string;
  theme?: Theme;
  themeName?: string;
  onReloadRequest: React.Dispatch<void>;
  onUpgrade: React.Dispatch<void>;
  onTrial: React.Dispatch<void>;
  hasTried: boolean;
  tutorials?: string[];
};

const Subscriptions: React.FC<SubscriptionProps> = (
  props: SubscriptionProps
) => {
  const { t } = useTranslation('settings');

  const [isPopoverVisible, setIsPopoverVisible] = useState(
    !props.tutorials?.includes('subscriptions-settings')
  );

  return (
    <SubscriptionsContainer>
      <h1>{t('SUBSCRIPTIONS_MANAGEMENT_TITLE')}</h1>
      <SubscriptionsContent>
        {props.entObj?.apps?.length === 0 && (
          <NoApps
            onUpgrade={props.onUpgrade}
            hasTried={props.hasTried}
            compact
            tid={props.tid}
          />
        )}
        {props.appsObj &&
          props.entObj &&
          props.entObj?.subscriptions?.map((sub) => {
            const obj = JSON.parse(JSON.stringify(sub));
            return (
              <SubscriptionCard
                subscription={obj}
                key={obj?.id}
                apps={props.appsObj}
                currentUser={props.currentUser}
                tid={props.tid}
                theme={props.theme}
                themeName={props.themeName}
                onReloadRequest={props.onReloadRequest}
                onUpgrade={props.onUpgrade}
              />
            );
          })}
      </SubscriptionsContent>
      <HelpPanel
        appId="subscriptions-settings"
        firstRunEnabled={!props.tutorials?.includes('subscriptions-settings')}
      />

      <TutorialPopover
        appId="subscriptions-settings"
        scope="subscriptions-settings"
        dimissPopover={() => setIsPopoverVisible(false)}
        title="Subscriptions Management"
        isVisible={isPopoverVisible}
      />
    </SubscriptionsContainer>
  );
};

export default Subscriptions;
